/**
 * FX-PORT: sample 2 กระบี่ธารเยือกแข็งเฉือน (sheared ribbons along the dash, skid, star, frost glints) on ปลายกระบี่เยือกธาร
 * (ss-frost, a dash to the foe: drawn from where the dash started; its split-body afterimages are the dash's own).
 */
import { portSample } from './sampleArt/fromSample';

portSample('snow', { skills: ['ss-frost'], on: true, pre: 0.5, hit: 0.95, end: 1.75, dash: 52 });
